import React from "react";

import BackButton from "./BackButton";
import styles from "./mobileFooterButtons.scss";

const MobileFooterButtons = ({ onLeftClick, onRightClick, leftText = null }) => (
  <div className={styles.wrap}>
    <BackButton text={"Natrag"}></BackButton>
    <div className={styles.buttons}>
      {!leftText ? null : (
        <span
          role="button"
          tabIndex={0}
          onClick={onLeftClick}
          className={styles.buttonAddMore}
        >
          {leftText}
        </span>
      )}
      <span
        role="button"
        tabIndex={0}
        onClick={onRightClick}
        className={styles.buttonSearch}
      >
        {"Pretraži"}
      </span>
    </div>
  </div>
);

export default MobileFooterButtons;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/MobileFooterButtons/index.tsx